import { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import type { SubjectType } from '@casl/ability';
import { getStorage, setStorage } from 'forstok-ui-lib';
import type { TUser } from 'forstok-ui-lib';
import MyAbility from '../../../../utils/ability';
import cookies from '../../../../utils/cookies';
import { Can } from '../../../../components/can';
import { getPermission } from '../../../../assets/javascripts/config';
import { headers } from '../../../../maps/common';
import { TPermission } from '../../typed';
import { destroyUser } from '../logout';
import { TWarehouseFilter } from '../../../../typeds/shares.typed';
import { client } from '../../../../utils/forstok';
import { WarehouseListDocument } from '../../../../typeds/graphql.typed';

const PrivateRoute = ({ as }:{ as?: string }) => {
  const [auth, setAuth] = useState<boolean|undefined>();

  const location = useLocation()
  
  useEffect(() => {
    const controller = new AbortController();
    let effectStale = false;
    let isAuth = cookies.get('token') ? true : false;
    if (isAuth) {
      const users: TUser | undefined = getStorage('users', 'object');
      if (!users || !users?.profile_id || !users?.id || !users?.credentials) {
        const userCookies = cookies.get('users');
        if (userCookies) {
          setStorage('users', JSON.stringify(userCookies), 'local');
        } else {
          isAuth = false;
        }
      }
      if (isAuth) {
        void (async () => {
          try {
            const response = await fetch('https://integration.forstok.com/dashboard_user', {
              method: 'GET',
              headers: headers('application/json'),
              signal: controller.signal,
            });
            const res = await response.json();
            isAuth = res.success;
          } catch {
            // Preserve the existing auth state when the request fails.
          }
        })();
      }
    }
    if (effectStale) {
      return;
    }
    if (isAuth) {
      const permission:TPermission[] = cookies.get('permission') || [];
      if (permission?.length) {
        const results = permission.map(_permission => {
          return { id: _permission.id, group: _permission.group, name: _permission.name };
        });
        MyAbility.update(getPermission(results));
      }
    }
    setAuth(isAuth);

    const fetchWarehouse = async () => {
      const _warehousesArr: TWarehouseFilter = []
      await client.query({
        query: WarehouseListDocument,
      }).then((response) => {
        if(response.data.warehouses) {
          for (const warehouse of response.data.warehouses) {
            _warehousesArr.push({
              id: warehouse?.id || 0, 
              name: warehouse?.name || '-'
            })
          }
        }
      }).catch(() => {
        _warehousesArr.push({
          id: 999999, 
          name: '-'
        })
      })
      setStorage('filterWarehouse', JSON.stringify(_warehousesArr))
      window.location.reload();
    }
    const warehouseFilter: TWarehouseFilter | undefined = getStorage('filterWarehouse', 'array', []);
    if (!warehouseFilter?.length && isAuth) void fetchWarehouse()

    return () => {
      controller?.abort();
      effectStale = true;
    };
  }, [location])

  const ExcludeCan = ['']

  if (auth === undefined) {
    return null;
  } else {
    if (auth) {
      if (MyAbility && (as && !ExcludeCan.includes(as))) {
        return (
          <Can I='load' a={as as SubjectType} ability={MyAbility as any} passThrough>
            { can => can ? <Outlet /> : <Navigate to='/restricted' /> }
          </Can>
        );
      } else {
        return <Outlet />;
      }
    } else {
      void destroyUser();
      return <Navigate to='/users/login?k=exp' />;
    }
  }
};

export default PrivateRoute;